module.exports = __webpack_public_path__ + "img/ls5.664c980a.png";